const getFieldPathsAlongPath = (path: string, includeEntire: 'INCLUDE_ORIGINAL' | 'EXCLUDE_ORIGINAL') => {
    const fieldsOnPath = path.split('.');
    let allPaths = [];
    for (let i = 1; includeEntire === 'INCLUDE_ORIGINAL' ? i <= fieldsOnPath.length : i < fieldsOnPath.length; i++) {
        allPaths.push(fieldsOnPath.slice(0, i).join('.'));
    }
    return allPaths;
};
export default getFieldPathsAlongPath;
